import { render, staticRenderFns } from "./auction-dialog.vue?vue&type=template&id=2a4624bf&"
import script from "./auction-dialog.vue?vue&type=script&lang=js&"
export * from "./auction-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports